/* eslint-disable no-use-before-define */

import React, { memo } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const icon = <i className="far fa-square"></i>;
const checkedIcon = <i className="fas fa-check-square"></i>;

const DropdownMultiCheckbox = props => {
  const options = props.setFirstLetter ? props.optionList.map(props.setFirstLetter) : props.optionList.map(option => {
    const firstLetter = option.title[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter, ...option
    };
  });

  return (<Autocomplete
      disabled={props.disabled}
    multiple={!!props.isMultiple}
      id="checkboxDrowdown"
      className={"checkbox-dropdown w-100 " + (props.className || " ")}
      disableCloseOnSelect
      onChange={(_, value) => props.onChange(value)}
      defaultValue={props.defaultValue}
      value={props.value || props.defaultValue}
      options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
      groupBy={option => option.firstLetter}
      getOptionLabel={option => option.title}
      getOptionSelected={(option, value) => {
        if (value) {
          return option.title === value.title;
        }
      }}
    renderOption={(option, { selected }) => (
      <React.Fragment>
          <Checkbox
            icon={icon}
            className="ic-checkbox"
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.title}
      </React.Fragment>)
    }
      renderInput={params => (<TextField {...params} placeholder={props.placeholder} />)}
    />);
};

export default memo(DropdownMultiCheckbox);
